import * as $ from 'jquery';
import * as log from 'loglevel';
import {sortBy} from "lodash"
import * as ko from 'knockout';
import {getPrimaryScreenVisibilityOptions} from "../ScreenVisibility";
import {ComputedOptions} from "~knockout/index";
import {Screen} from "../Screen";
import {showPrimaryScreen, getScreenParams} from '../ScreenManager';
import {globalConfig} from '../../config/Config';
import {ILeaderboardEntry} from 'power-patrol';
import {ObservableArray} from '~knockout/index';
import {Observable} from '~knockout/index';
import {Computed} from '~knockout/index';


var template = require('./LeaderboardScreen.html');

class LeaderboardScreenComponent
{
    public visible: Computed<boolean>;
    leaderboardData: ObservableArray<ILeaderboardEntry>;
    activeScore: Observable<number>;

    constructor()
    {
        this.createBindings();
    }


    /**
     * create knockout bindings
     */
    createBindings()
    {
        //  create super-class bindings

        this.visible = ko.computed(this.getVisibleOptions());

        this.visible.subscribe((visible: boolean) => this.onVisibilityChange(visible));

        //  create leaderboard data binding

        this.activeScore = ko.observable();
        this.leaderboardData = ko.observableArray([]);
    }


    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getPrimaryScreenVisibilityOptions('leaderboard');
    }


    /**
     * when this screen's visibility changes, do something
     */
    onVisibilityChange(visible: boolean)
    {
        visible ? this.onShow() : this.onHide();
    }



    /**
     * go back to the main menu
     */
    showMainMenu()
    {
        showPrimaryScreen('main-menu');
    }


    /**
     * when we show the game screen, start the game
     */
    onShow()
    {
        //  reset teh current scroll position

        setTimeout(() =>
        {
            this.resetScrollPosition();
        }, 10);


        //  load the scoreboard data

        $.getJSON(globalConfig.leaderboardUrl + '/api/leaderboard', (data: ILeaderboardEntry[]) =>
        {
            this.leaderboardData(sortBy(data, 'score').reverse());

            //  highlight the user's score

            this.highlightPosition();

            //  scroll to the new position

            this.scrollToPosition();
        });
    }


    onHide()
    {

    }


    /**
     * highlight the player's current high-score
     */
    highlightPosition()
    {
        var screenParams: any;

        //  get any current screen params

        screenParams = getScreenParams();

        log.debug('highlighting position:', screenParams);

        //  if no score has been submitted, just open the screen

        if (screenParams === undefined) return;

        //  if a score has been submitted, let's highlight it

        this.activeScore(screenParams - 1);
    }


    /**
     * reset the current scroll position
     */
    resetScrollPosition()
    {
        //TweenMax.set('#scoreboard-scrolling-container', { scrollTo: 0 });

        document.getElementById('scoreboard-scrolling-container').scrollTop = 0;

        console.log(document.getElementById('scoreboard-scrolling-container'))
    }


    /**
     * tween to the new score position
     */
    scrollToPosition()
    {
        var highlightEl: HTMLElement;

        //this.activeScore(21);

        //  get the currently highlighted element

        highlightEl = <HTMLElement>document.getElementsByClassName('highlight').item(0);

        //  if we don't have a highlighted element, stop here

        if ( ! highlightEl) return;

        //  if we do, scroll to that position

        TweenMax.to('#scoreboard-scrolling-container', 3, { scrollTo: $(highlightEl).offset().top - $(window).height() * 0.5, ease: Quad.easeInOut });
    }
}


/**
 * register this component with knockout
 * @param vizID
 */
export function registerLeaderboardScreenComponent()
{
    ko.components.register('pp-leaderboard',
        {
            viewModel: () => { return new LeaderboardScreenComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/leaderboard/LeaderboardScreen.ts